import React from 'react';

const Notification = ({ notification, onClose, isDropdownItem, onClick }) => {
  const { id, type, message, title, timestamp, read } = notification;

  const getIcon = () => {
    // Basic icon logic, can be expanded
    return 'fas fa-info-circle text-primary';
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose(id);
  };

  if (isDropdownItem) {
    return (
      <div
        className={`dropdown-item ${read ? 'text-muted' : ''}`}
        style={{ whiteSpace: 'normal', cursor: 'pointer', borderBottom: '1px solid #eee', padding: '10px 16px' }}
        onClick={onClick}
      >
        <div className="d-flex align-items-start">
          <div className="me-2 mt-1">
            <i className={`${getIcon()} ${read ? '' : 'text-primary'}`} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            {title && <div style={{ fontWeight: read ? 'normal' : '600', fontSize: '0.85em', marginBottom: '2px' }}>{title}</div>}
            <p className="mb-1 text-wrap" style={{ fontSize: '0.82em', whiteSpace: 'pre-line', color: read ? '#888' : '#333' }}>{message}</p>
            <small className="text-muted" style={{ fontSize: '0.75em' }}>
              {new Date(timestamp).toLocaleString()}
            </small>
          </div>
        </div>
      </div>
    );
  }

  // Toast Style
  return (
    <div className={`notification notification-${type || 'info'}`} style={{ marginBottom: '10px', background: 'white', padding: '10px', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)', display: 'flex', position: 'relative' }}>
      <div className="notification-icon" style={{ marginRight: '10px' }}>
        <i className={getIcon()} />
      </div>
      <div className="notification-content" style={{ paddingRight: '20px' }}>
        {title && <div className="notification-title" style={{ fontWeight: 'bold' }}>{title}</div>}
        <div className="notification-message">{message}</div>
      </div>
      {onClose && (
        <button className="notification-close" onClick={handleClose} style={{ position: 'absolute', top: '5px', right: '5px', border: 'none', background: 'transparent', cursor: 'pointer' }}>
          <i className="fas fa-times" />
        </button>
      )}
    </div>
  );
};

export default Notification;